import { render, staticRenderFns } from "./MainPageSettings.vue?vue&type=template&id=360c9ff6"
import script from "./MainPageSettings.vue?vue&type=script&lang=js"
export * from "./MainPageSettings.vue?vue&type=script&lang=js"
import style0 from "./MainPageSettings.vue?vue&type=style&index=0&id=360c9ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports